import { Users, Maximize2 } from 'lucide-react'
import { Separator } from '@/components/ui/separator'
import { VI_MESSAGES } from '@/constants/vietnamese'
import { formatNumber } from '@/utils/vietnamese-format'
import type { WardInfo } from '@/types/ward'

interface WardInfoContentProps {
  ward: WardInfo
}

export function WardInfoContent({ ward }: WardInfoContentProps) {

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h3 className="text-xl font-bold">{ward.xaphuong}</h3>
      </div>

      <Separator />

      {/* Statistics Grid */}
      <div className="grid grid-cols-2 gap-4">
        {/* Dân số */}
        {ward.danso && (
          <div className="flex items-start gap-3">
            <div className="rounded-lg bg-blue-100 p-2">
              <Users className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-xs text-gray-500">{VI_MESSAGES.WARD.LABELS.POPULATION}</p>
              <p className="text-lg font-semibold">{formatNumber(ward.danso)}</p>
              <p className="text-xs text-gray-500">{VI_MESSAGES.WARD.UNITS.POPULATION}</p>
            </div>
          </div>
        )}

        {/* Diện tích */}
        {ward.dientichpl && (
          <div className="flex items-start gap-3">
            <div className="rounded-lg bg-green-100 p-2">
              <Maximize2 className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="text-xs text-gray-500">{VI_MESSAGES.WARD.LABELS.AREA}</p>
              <p className="text-lg font-semibold">{formatNumber(ward.dientichpl, 2)}</p>
              <p className="text-xs text-gray-500">km²</p>
            </div>
          </div>
        )}
      </div>

      {/* Official Information */}
      {(ward.chutich || ward.bithu || ward.mattran) && (
        <>
          <Separator />
          <div className="space-y-3">
            {/* Chairman Info */}
            {ward.chutich && (
              <div>
                <p className="text-sm font-medium text-gray-700">
                  {VI_MESSAGES.WARD.LABELS.CHAIRMAN}
                </p>
                <p className="text-base font-semibold">{ward.chutich}</p>
              </div>
            )}

            {/* BITHU Info */}
            {ward.bithu && (
              <div>
                <p className="text-sm font-medium text-gray-700">
                  {VI_MESSAGES.WARD.LABELS.BITHU}
                </p>
                <p className="text-base font-semibold">{ward.bithu}</p>
              </div>
            )}

            {/* MATTRAN Info */}
            {ward.mattran && (
              <div>
                <p className="text-sm font-medium text-gray-700">
                  {VI_MESSAGES.WARD.LABELS.MTTQ}
                </p>
                <p className="text-base font-semibold">{ward.mattran}</p>
              </div>
            )}
          </div>
        </>
      )}

    </div>
  )
}